import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useSnackbar } from 'notistack';
import * as XLSX from 'xlsx/xlsx.mjs';
import LeadsStatusesFetchContext from '@/modules/leads_statuses/contexts/LeadsStatusesFetchContext';
import Button from '@/modules/common/components/Button';
import TextField from '@/modules/common/components/TextField';
import UploadButton from '@/modules/common/components/UploadButton';
import { actionSetLeadsStatusesFetchIds } from '@/modules/application/actions/leads_statuses/fetch';

const Fetch = (props) => {
    const { enqueueSnackbar } = useSnackbar();

    const leadsStatusesFetchContext = useContext(LeadsStatusesFetchContext);
    const loading = leadsStatusesFetchContext.loading;
    const data = leadsStatusesFetchContext.data;
    const isFiltered = leadsStatusesFetchContext.isFiltered;
    const errors = leadsStatusesFetchContext.errors;
    const setErrors = leadsStatusesFetchContext.setErrors;

    const [reading, setReading] = useState(false);

    const handleFocus = (prop) => () => {
        setErrors({...errors, [prop]: ''});
    };

    const handleUpload  = (event) => {
        event.preventDefault();

        const reader = new FileReader();
        const file = event.target.files[0];

        // const regExp = new RegExp('(.*?)\.(xls|xlsx)$');
        // if (!regExp.test(file.name)) {
        //     enqueueSnackbar('Формат файла не поддерживается', {variant: 'error'});
        //     return;
        // }
        if (!file.size) {
            enqueueSnackbar('Файл пуст', {variant: 'error'});
            return;
        }

        reader.readAsBinaryString(file);
        reader.onloadstart = () => {
            setReading(true);
        };
        reader.onload = (event) => {
            const wb = XLSX.read(event.target.result, {type: 'binary'});
            const sheetName = wb.SheetNames[0];
            let sheet = wb.Sheets[sheetName];
            sheet = XLSX.utils.sheet_to_json(sheet, {header: 1});
            sheet = sheet.slice(1);
            const ids = sheet.map(row => row[0]);
            props.setIds(ids.join(' '));
        };
        reader.onloadend = () => {
            setReading(false);
        };
    };

    return (
        <form id="form-fetch" onSubmit={props.onSubmit}
              className={(loading || (data || isFiltered)) ? 'hidden' : ''}
        >
            <TextField label="Список ID" multiline={true}
                       value={props.ids} onChange={(event) => props.setIds(event.target.value)}
                       error={errors.ids.length > 0}
                       helperText={errors.ids}
                       onFocus={handleFocus('ids')}
            />
            <div className="actions">
                <div>
                    <UploadButton id="upload-file" onChange={handleUpload}
                                  inputProps={{
                                      accept: 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                                  }}
                                  buttonProps={{
                                      disabled: reading,
                                  }}
                    >
                        Загрузить таблицу
                    </UploadButton>
                    <Button type="submit" disabled={(loading || !props.ids.length)}>Выгрузить</Button>
                </div>
            </div>
        </form>
    );
};

Fetch.propTypes = {
    onSubmit: PropTypes.func.isRequired,
};

export default connect(
    (state) => ({
        ids: state.leads_statuses_fetch.ids,
    }),
    (dispatch) => ({
        setIds: bindActionCreators(actionSetLeadsStatusesFetchIds, dispatch),
    })
)(Fetch);
